import type { WidgetThemeApiPayload } from '@/lib/widget/widget-theme-merge';

/**
 * Loads operator-saved theme for a site (best-effort). Used at widget bootstrap
 * so "Save Theme" in the portal applies without re-pasting the embed snippet.
 *
 * Uses `credentials: 'same-origin'` so operator previews on SSO-protected hosts
 * (staging / Vercel Deployment Protection) can send the protection cookie when
 * the widget and theme API share an origin. Cross-origin customer embeds still
 * omit cookies — `same-origin` only attaches credentials for same-origin URLs.
 */
export async function fetchWidgetTheme(
  apiOrigin: string,
  siteId: string,
): Promise<WidgetThemeApiPayload | null> {
  const base = apiOrigin.replace(/\/+$/, '');
  const url = `${base}/api/engage/widget/theme?site_id=${encodeURIComponent(siteId)}`;

  try {
    const res = await fetch(url, { method: 'GET', credentials: 'same-origin' });
    if (!res.ok) {
      return null;
    }
    const data: unknown = await res.json();
    if (!data || typeof data !== 'object') {
      return null;
    }
    return data as WidgetThemeApiPayload;
  } catch {
    return null;
  }
}
